import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/nintendo-switch': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M95.9 33.5C51.3 41.5 15.4 74.5 4.1 117.9 0 133.6-0.3 142.8 0.2 264.4 0.4 376 0.5 378.6 2.4 387.3 12.7 433.8 45.7 466.9 92.7 477.8 98.8 479.2 106.6 479.5 156.8 479.7 208.7 480.1 214.1 480 215.5 478.6 216.9 477.2 217 459.3 217 256.4 217 105.9 216.7 35.1 216.1 33.8 215.2 32.1 213.6 32 159.2 32.1 115 32.2 101.7 32.5 95.9 33.5zM179.8 256.1V444L142 443.5C107.2 443.1 103.5 442.9 96.5 441.2 66.6 433.5 44.5 410.5 38.2 380.5 36.2 371.1 36.2 140.4 38.1 131.2 43.7 105.1 61.8 83.5 86.1 73.8 98.3 68.9 104 68.3 143.7 68.2L179.6 68.1V256.1zM103.9 124.9C98.1 126 89.2 130.5 84.4 134.6 74.7 143 69.8 155 70.6 169.1 71 176.4 71.4 178.4 74.4 184.3 78.8 193.3 85.3 199.9 94.3 204.3 100.5 207.4 102.1 207.7 110.2 208 117.5 208.3 120.1 208 125 206.3 145.1 199.5 157.3 180 153.8 159.9 149.9 136.2 127.2 120.2 103.9 124.9zM262.1 32.6C261.7 32.9 261.5 133.4 261.5 256.1 261.5 458.4 261.6 478.9 263 479.5 265.5 480.4 337.5 480.1 346.4 479.1 384.1 474.8 417.4 451.9 435.4 417.9 437.7 413.5 440.8 406.2 442.4 401.7 448.2 384.3 448.1 388.9 448.1 255.6 448.1 149.2 447.9 133.3 446.6 126.6 437.4 78.3 400.5 41.8 352.1 33.5 345.6 32.4 335.6 32.1 303.3 32.1 280.9 32 262.4 32.3 262.1 32.6zM361.2 234.7C375.7 238.5 387.5 249.5 392.4 263.6 395.5 272.3 395.4 285.1 392.3 293.1 386.6 307.8 375.5 318.1 361.2 321.9 338 327.9 313.3 313.9 306.6 290.9 304.6 283.9 304.7 272 307 264.7 313.9 242 338 228.6 361.2 234.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/nintendo-switch.js
// module id = xGknU
// module chunks = 144